'use client';

import React from 'react';
import { 
  ClockIcon, 
  ListBulletIcon,
} from '@heroicons/react/24/outline';

export type WatchlistView = 
  | 'watchlists' 
  | 'common-stocks' 
  | 'intersection-stocks' 
  | 'recent-stocks';

interface WatchlistNavigationProps {
  currentView: WatchlistView;
  onViewChange: (view: WatchlistView) => void;
  onLoadRecentStocks: () => void;
  className?: string;
}

const WatchlistNavigation: React.FC<WatchlistNavigationProps> = ({
  currentView,
  onViewChange,
  onLoadRecentStocks,
  className = ""
}) => {
  const navigationItems = [
    {
      id: 'watchlists' as WatchlistView,
      label: 'My Lists',
      icon: ListBulletIcon,
      onClick: () => onViewChange('watchlists'),
      description: 'View all watchlists'
    },
    {
      id: 'recent-stocks' as WatchlistView,
      label: 'Recent',
      icon: ClockIcon,
      onClick: onLoadRecentStocks,
      description: 'Recently added stocks'
    }
  ];

  return (
    <div className={`flex gap-6 overflow-x-auto border-b border-zinc-200 dark:border-zinc-800 ${className}`}>
      {navigationItems.map((item) => (
        <button
          key={item.id}
          onClick={item.onClick}
          className={`-mb-px flex items-center gap-2 border-b-2 py-3 text-sm font-medium transition-colors whitespace-nowrap ${
            currentView === item.id
              ? 'border-emerald-700 text-zinc-900 dark:border-emerald-400 dark:text-white'
              : 'border-transparent text-zinc-500 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white'
          }`}
        >
          <item.icon className="h-4 w-4" />
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default WatchlistNavigation; 